import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import SearchComponent from "../components/SearchComponent";
import { handleSearch } from "../utils/searchUtils";
import { AiOutlineInfo } from "react-icons/ai";
import { LiaToolsSolid } from "react-icons/lia";
import { IoMdArrowRoundBack } from "react-icons/io";

import { useCatalog } from "../context/CatalogContext";
import * as Types from "../data-types/api-client/api-products";
import { IconComponent } from "../components/IconComponent";
import ModalComponent from "../components/ModalComponent";
import Carousel from "../components/Carousel";
import { formatCurrency } from "../utils/numberFormatter";
import ImageViewer from "../components/ImageViewer";
import { useParams } from "react-router-dom";
import { MdOutlineGroup } from "react-icons/md";

const ItemDetail: React.FC = () => {
  const navigate = useNavigate();
  const { provisionData, originalTitle } = useCatalog();

  const [isViewerImageOpen, setViewerImage] = useState(false);
  const { productId } = useParams<{ productId: string }>();
  const { category } = useParams();
  const priceList: Types.RentPriceList = provisionData?.priceList;

  const openViewerImage = () => {
    setViewerImage(true);
  };

  const activeProductIdx = productId ? parseInt(productId, 10) : 0;
  const devices: Types.RentDevice[] = provisionData?.priceList?.devices;
  const device: Types.RentDevice | undefined = devices?.find(
    (device) => device.id === activeProductIdx,
  );

  const activeCategory = provisionData?.categories?.find(
    (cat) => cat.id === device?.rentCategoryId,
  );
  const activeCategoryName = activeCategory?.name;

  //filter only one selected device using index
  const images = device?.images;
  const [modalOpen, setModalOpen] = useState(false);

  const openModal = () => {
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
  };

  return (
    // <div className="flex flex-col w-full bg-custom-gray-100 md:px-20 px-4 justify-center">
    <div className="flex flex-col items-center justify-center h-full w-full justify-self-center pb-8 2xl:w-3/4 bg-custom-white">
      <div className="bg-custom-gray flex flex-col justify-self-center items-center h-full md:px-20 sm:px-8 px-4 w-full gap-3 py-0 pb-8">
        <div className="flex w-full items-center gap-2 pt-4 pb-1">
          {" "}
          <span className="flex items-center justify-center w-9 h-9 rounded-xl text-custom-red bg-custom-white">
            <LiaToolsSolid className="text-lg" />
          </span>
          <h2 className="flex w-full justify-start items-center uppercase text-custom-blue font-semibold text-base">
            Detail produktu
          </h2>
        </div>
        <div className="flex-col w-full h-full text-custom-atrament rounded-lg bg-custom-white md:px-8 pt-2 justify-self-center">
          {/* Back to category link upper */}
          <div className="flex mb-2 mt-2">
            <span className="flex justify-center md:justify-start hover:underline">
              <Link
                to={"/prenajom-zariadeni"}
                className="flex bg-custom-white w-full h-[3rem] flex-row gap-2 mb-2 items-center font-light text-baseline ml-2 md:ml-0 text-custom-atrament pl-2"
              >
                <div className="flex p-1.5 items-center justify-center rounded-full bg-custom-atrament text-custom-white">
                  <IoMdArrowRoundBack className="text-custom-white md:text-3xl text-2xl" />
                </div>
                {activeCategoryName}
              </Link>
            </span>
          </div>
          <div className="flex flex-col lg:flex-row lg:gap-8 gap-6 w-full px-3">
            {/* Image Container */}
            {images && (
              <div
                className="    flex-shrink-0
    overflow-hidden
    bg-custom-white
    h-80
    w-full
    lg:w-1/2
    xl:w-[30rem]
    2xl:w-[40rem]
    border
    border-custom-blue/10

    rounded-2xl
    sm:shadow-base

    p-3
    sm:p-4"
              >
                {images?.length > 1 && (
                  <div
                    className="    flex
      h-[260px]
      w-full
      px-8
      items-center
      justify-center
      overflow-hidden"
                  >
                    {" "}
                    <div className="w-full">
                      <Carousel images={images}></Carousel>
                    </div>
                  </div>
                )}

                {images?.length === 1 && (
                  <img
                    src={images?.[0].url}
                    alt={originalTitle}
                    className="w-full h-full object-contain cursor-pointer"
                    onClick={() => openViewerImage()}
                  />
                )}
                {images?.length === 0 && (
                  <div className="flex items-center justify-center h-full">
                    <IconComponent
                      iconPath={
                        "/data/images/categories/1221637e-a67b-4dd0-ad15-701034d13804.svg"
                      }
                      className="text-9xl"
                    />
                  </div>
                )}
                {isViewerImageOpen && (
                  <ImageViewer
                    images={images}
                    isViewerImageOpen={isViewerImageOpen}
                    onClose={() => setViewerImage(false)}
                  />
                )}
              </div>
            )}

            {/* Text Container */}
            <div className="flex flex-col xl:w-[30rem] w-full rounded-xl bg-custom-white h-auto">
              <div className="h-full">
                <h2 className="text-2xl font-bold mb-1">{originalTitle}</h2>
                {device && (
                  <div>
                    <p className="mb-4 uppercase font-semibold text-custom-blue-600">
                      {device?.model}
                    </p>
                    <p className="text-custom-gray-600">
                      {device?.description}
                    </p>
                  </div>
                )}
              </div>
              <div className="flex h-full place-items-end lg:mt-2 flex-col">
                <div className="flex w-full h-full justify-center mb-4 lg:mt-8 mt-6 gap-8 font-bold">
                  {device?.type === Types.RentType.RENT && device.price5h && (
                    <div className="flex w-1/2 justify-center shadow-xl rounded-lg">
                      <div className="flex flex-col items-center w-full">
                        <div className="flex justify-center rounded-t-lg rounded-b-none items-center flex-col mb-5 font-semibold  bg-custom-gray-100 h-[4rem] w-full">
                          <div className="h-full py-2">
                            <p className="flex font-medium md:text-base text-basew-full flex-wrap justify-center">
                              Cena pri vrátení:
                            </p>
                            <p className="flex md:text-xl justify-center text-xl">
                              do 5 hodín
                            </p>
                          </div>
                        </div>

                        {device?.price5h && (
                          <div className="flex flex-wrap items-baseline space-x-1 md:mt-20 mt-10 pb-2 justify-center">
                            <span className="flex md:text-4xl text-2xl items-center">
                              {formatCurrency(device?.price5h)}
                            </span>
                            <span className="flex text-xs ml-1 pt-2 font-semibold items-center whitespace-nowrap">
                              s DPH
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {device?.type === Types.RentType.RENT && device.price24h && (
                    <div className="flex w-1/2 justify-center shadow-xl rounded-lg">
                      <div className="flex flex-col items-center w-full">
                        <div className="flex justify-center rounded-t-lg rounded-b-none items-center flex-col mb-5 font-semibold  bg-custom-gray-100 h-[4rem] w-full">
                          <div className="h-full py-2">
                            <p className="flex font-medium md:text-base text-basew-full flex-wrap justify-center">
                              Cena nájmu:
                            </p>
                            <p className="flex md:text-xl justify-center text-xl">
                              na 1 deň
                            </p>
                          </div>
                        </div>
                        {device?.price24h && (
                          <div className="flex flex-wrap items-baseline space-x-1 md:mt-20 mt-10 pb-2 justify-center">
                            <span className="flex md:text-4xl text-2xl items-center">
                              {formatCurrency(device?.price24h)}
                            </span>
                            <span className="flex text-xs ml-1 pt-2 font-semibold items-center whitespace-nowrap">
                              s DPH
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  {device?.type === Types.RentType.SERVICE && device.price && (
                    <div className="flex w-1/2 justify-center shadow-xl">
                      <div className="flex flex-col items-center w-full">
                        <div className="flex justify-center items-center flex-col mb-5 font-semibold  bg-custom-gray-100 h-[4rem] w-full">
                          <div className="py-2">
                            <p className="flex md:text-xl justify-center text-xl">
                              Cena:
                            </p>
                          </div>
                        </div>
                        {device?.price && (
                          <div className="flex flex-wrap items-baseline space-x-1 md:mt-20 mt-10 pb-2 justify-center">
                            <span className="flex md:text-4xl text-2xl items-center">
                              {formatCurrency(device?.price)}
                            </span>
                            <span className="flex text-xs ml-1 pt-2 font-semibold items-center whitespace-nowrap">
                              s DPH
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  )}
                </div>
                {device?.foreignerDeposit && (
                  <p className="flex bg-custom-mustard-200/30 rounded-lg lg:py-4 py-2 font-medium italic text-xs h-1/2 w-full bg-custom-gray mt-2 mb-6 px-3 items-center">
                    <div className="flex p-1.5 items-center mr-3 justify-center rounded-lg border border-custom-red-light bg-custom-white text-custom-blue">
                      <AiOutlineInfo />
                    </div>
                    Kaucia pre občanov mimo okresy TS, NO a DK:{" "}
                    {device?.foreignerDeposit
                      ? formatCurrency(device.foreignerDeposit, true)
                      : ""}
                  </p>
                )}

                <button
                  className="w-full uppercase hover:border-custom-red hover:bg-custom-red bg-custom-atrament text-custom-white h-[3rem] px-4 py-2 rounded-md transition duration-200"
                  onClick={openModal}
                >
                  Rezervovať
                </button>
              </div>
            </div>
          </div>
          <div className="flex mt-16 px-4 md:px-0 flex-col w-full">
            {device?.accessories && device?.accessories?.length > 0 ? (
              <div className="flex flex-col w-full">
                <div className="flex bg-bg-light uppercase border-l-4 border-custom-red font-semibold py-3 pl-1 pl-1 md:pl-2 text-bg-gray-500">
                  Príslušenstvo:
                </div>
                <div
                  id="productSection"
                  // className="flex mt-2 w-full text-custom-atrament justify-self-center mb-6 pb-4 bg-custom-mustard"
                  className="
    grid
    grid-cols-1
    xl:grid-cols-2
    gap-4
    w-full
    py-4
    mx-auto
  "
                >
                  {/* <div className="flex flex-wrap md:flex-row flex-col gap-4 items-center md:justify-start justify-center"> */}
                  {device?.accessories?.map((accessory, index) => (
                    <div
                      key={index}
                      className="flex flex-row border border-custom-gray-200 sm:flex-col items-center justify-self-center w-full h-[6rem] md:h-[5.3rem]"

                      // className="flex flex-row border border-custom-gray-200 sm:flex-col items-center justify-self-center w-full h-[6rem] md:h-[5.3rem] xl:w-[34rem] max-w-[500px]"
                      // className="flex flex-row border border-custom-gray-200 sm:flex-col items-center justify-self-center w-full h-[6rem] md:h-[5.3rem] xl:w-[34rem]"
                    >
                      <div className="flex h-full w-full">
                        <p
                          className="flex items-center justify-start font-light text-sm 
                      h-full w-full px-1 md:px-2 md:py-2 py-1"
                        >
                          {accessory.name}
                        </p>
                        <div className="flex gap-4 h-full items-center justify-center border-l border-custom-gray-200 font-bold">
                          {accessory?.price5h && !accessory?.price24h && (
                            <div className="flex flex-col gap-0.5 md:gap-1 justify-center items-center h-full md:h-full md:w-[8rem] bg-custom-gray-100 text-center">
                              <span className="flex font-semibold text-sm">
                                Vrátenie do 5h:{" "}
                              </span>
                              <span className="flex text-base">
                                {formatCurrency(accessory?.price5h)}
                              </span>
                              <span className="flex text-xs font-semibold whitespace-nowrap">
                                s DPH
                              </span>
                            </div>
                          )}
                          {accessory?.price5h && accessory?.price24h && (
                            <div className="flex gap-0.5 md:gap-1 justify-center items-center h-full md:h-full md:w-[16rem] w-[12rem] text-center">
                              <div className="flex flex-col bg-custom-gray-100 w-1/2 h-full justify-center items-center">
                                {" "}
                                <span className="flex font-semibold text-sm">
                                  Nájom do 5h:{" "}
                                </span>
                                <span className="flex text-base">
                                  {formatCurrency(accessory?.price5h)}
                                </span>
                                <span className="flex text-xs font-semibold whitespace-nowrap">
                                  s DPH
                                </span>
                              </div>
                              <div className="flex flex-col bg-custom-gray-100 w-1/2 h-full justify-center items-center">
                                {" "}
                                <span className="flex font-semibold text-sm">
                                  Nájom na 1 deň:
                                </span>
                                <span className="flex text-base">
                                  {formatCurrency(accessory?.price24h)}
                                </span>
                                <span className="flex text-xs font-semibold whitespace-nowrap">
                                  s DPH
                                </span>
                              </div>
                            </div>
                          )}
                          {accessory?.price24h && !accessory?.price5h && (
                            <div className="flex flex-col gap-0.5 md:gap-1 justify-center items-center h-full md:h-full md:w-[8rem] w-[6rem] bg-custom-gray-100 text-center">
                              <span className="flex font-semibold text-sm">
                                Nájom na 1 deň:
                              </span>
                              <span className="flex text-base">
                                {formatCurrency(accessory?.price24h)}
                              </span>
                              <span className="flex text-xs font-semibold whitespace-nowrap">
                                s DPH
                              </span>
                            </div>
                          )}
                          {accessory?.price && (
                            <div className="flex flex-col gap-0.5 md:gap-1 justify-center items-center h-full md:h-full md:w-[8rem] w-[6rem] bg-custom-gray-100 text-center">
                              <span className="flex font-semibold text-sm">
                                Cena:{" "}
                              </span>
                              <span className="flex text-base">
                                {formatCurrency(accessory?.price)}
                              </span>
                              <span className="flex text-xs font-semibold whitespace-nowrap">
                                s DPH
                              </span>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ) : (
              // </div>
              <></>
            )}

            {priceList?.additionalInformations &&
            priceList?.additionalInformations.length > 0 ? (
              <div>
                <div className="flex bg-bg-light uppercase border-l-4 border-custom-red font-semibold py-3 pl-1 pl-1 md:pl-2 text-bg-gray-500">
                  Doplnkové info:
                </div>
                <div className="overflow-x-auto mt-2">
                  {priceList?.additionalInformations?.map((info, index) => (
                    <table className="min-w-full rounded-lg text-xs">
                      <thead>
                        <tr>
                          <th
                            key={index}
                            className="px-4 py-2 text-left bg-gray-50 font-semibold text-muted-gray-blue bg-custom-gray-200"
                          >
                            {info.name}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {info.items?.map((item, index) => (
                          <tr
                            key={index}
                            className={
                              index % 2 === 1
                                ? "bg-custom-gray-100 text-muted-gray-blue"
                                : "bg-custom-white text-muted-gray-blue"
                            }
                          >
                            <td className="px-4 py-2">{item.item}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ))}
                </div>
              </div>
            ) : (
              <></>
            )}
          </div>
          <ModalComponent modalOpen={modalOpen} closeModal={closeModal} />
        </div>
      </div>
    </div>
  );
};

export default ItemDetail;
